module.exports = __webpack_public_path__ + "static/fonts/Mont-ThinItalic.f365850.woff";